import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"

// This component's purpose is to help test pages that render the block editor.
// If you want to render a page with a block editor but don't care about what's
// actually happening inside the blocks, you can use this component as a
// placeholder. That way, you don't need to mock the entire block context to
// test unrelated behavior.

export function Test({ id = "test-block-id" }) {
  const { properties, update } = useBlocks(id)

  return (
    <input
      type="text"
      data-testid="test-block"
      value={properties.value}
      onChange={e => update({ value: e.target.value })}
    />
  )
}
